
export default {
  components: {
    'id-diagram-lazy-related': () => import('~/components/diagram/lazy/Related.vue')
  },
  props: {
    diagramName: {
      type: String,
      required: true
    },
    diagramId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    frequentlyBought: []
  }),
  async fetch () {
    this.frequentlyBought = await this.$backend.diagrams.retrieve(this.diagramId, 'frequently_bought').then(d => d.results)
  }
}
